
export default {
  data() {
    return {
      activeTooltip: null,
    };
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    fieldId: {
      type: [String, Number],
      default: "",
    },
  },
};
